import React from 'react';
import { Icon, Skeleton } from 'ui';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const RolePlayTitle = ({ loading, title }) => {
  if (loading) {
    return (
      <div className="mb-16" data-testid="partnerGuideRolePlayTitleSkeleton">
        <Skeleton />
        <div />
      </div>
    );
  }

  return (
    <>
      <div className="d-f w-fill jc-sb ai-b fw-w mb-32">
        <div className="d-f ai-c">
          <Icon name="theater_masks" className="h-30 w-30" />
          <Text className="pl-10" variant={TEXT_VARIANTS.TITLE_BOLD}>
            {t('questions.question.role_play.title_guide')}
          </Text>
        </div>
      </div>
      <div className="mb-16 fz-32 pt-16">
        {title}
        <div />
      </div>
    </>
  );
};

export default RolePlayTitle;
